import { selectClasses } from '@mui/material';

export const ALIGN_ADORNMENT_TOP = {
  [`& .${selectClasses.icon}`]: {
    top: '6px',
  },
};
